module.exports = __webpack_public_path__ + "static/media/icon_scenario_dropdown.7646a08d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_scenario_dropdown.svg
// module id = 335
// module chunks = 0